import {useIsEmbedded} from '../../utils/embedded/useIsEmbedded'
import {useBrandCapabilities} from './useBrandCapabilities'

/**
 * Whether the current page is embedded AND the brand runs an embedded flow.
 */
const useIsEmbeddedWithBrand = (): boolean => {
  const isEmbedded = useIsEmbedded()
  const {shell} = useBrandCapabilities()

  return isEmbedded && shell.usesEmbeddedFlow
}

export {useIsEmbeddedWithBrand}
